export const types = {
  GET_AUDITS: 'audits/GET_AUDITS',
  GET_AUDITS_SUCCESS: 'audits/GET_AUDITS_SUCCESS',
  GET_AUDITS_FAILED: 'audits/GET_AUDITS_FAILED',

  GET_AUDITS_TYPES: 'audits/GET_AUDITS_TYPES',
  GET_AUDITS_TYPES_SUCCESS: 'audits/GET_AUDITS_TYPES_SUCCESS',
  GET_AUDITS_TYPES_FAILED: 'audits/GET_AUDITS_TYPES_FAILED',
};
